import React, { useEffect, useState } from 'react';
import { CheckCircle, Clock, Shield } from 'lucide-react';
import TrackingSystem from '../../pages/track-declaration/TrackingSystem';
import { useNavigate } from 'react-router-dom';

const styles = {
  primaryColor: '#F76707',
  secondaryColor: '#0A6EBD',
};

const ConfirmationStep = ({ trackingNumber }) => {
  const [redirectToTracking, setRedirectToTracking] = useState(false);
 
  const navigate = useNavigate();

  const handleTrackingClick = () => {
    // Navigation vers la page de suivi avec le numéro de tracking
    navigate(`/tracking/${trackingNumber}`);
  };

  
  if (redirectToTracking) {
    return (
      <div className="container-fluid">
        <TrackingSystem
          initialTrackingNumber={trackingNumber}
          autoSearch={true} 

        />
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="text-center p-5">
            <CheckCircle
              size={64}
              className="mb-4"
              color={styles.primaryColor}
            />
            <h2 className="mb-4" style={{ color: styles.secondaryColor }}>
              Nous avons bien reçu votre réclamation
            </h2>
            <div className="mb-4">
              <div className="alert alert-success mb-4" role="alert">
                <div className="d-flex align-items-center mb-2">
                  <Shield className="me-2" size={20} />
                  <strong>Votre demande est entre de bonnes mains</strong>
                </div>
                <p className="mb-0">
                  Notre équipe dédiée a été notifiée et traitera votre réclamation en priorité.
                </p>
              </div>

              <div className="mb-4">
                <Clock className="me-2" size={20} />
                <span>Délai de traitement estimé : 48 heures ouvrables</span>
              </div>

              <div className="bg-light p-4 rounded mb-4">
                <p className="mb-2">
                  Pour suivre l'avancement de votre réclamation, utilisez ce numéro de référence :
                </p>
                <span
                  className="fs-4 fw-bold"
                  style={{ color: styles.primaryColor }}
                >
                  {trackingNumber}
                </span>
                <p className="text-muted mt-2 small">
                  Conservez ce numéro précieusement pour tout échange futur
                </p>
              </div>

              <div className="alert alert-info mb-4" role="alert">
                <p className="mb-0">
                  <strong>Prochaine étape :</strong> Nos équipes analyseront votre demande et vous tiendront informé de son avancement.
                </p>
              </div>
            </div>

            <div className="d-flex justify-content-center gap-3">
              <button
                onClick={handleTrackingClick}
                className="btn px-4"
                style={{ backgroundColor: styles.primaryColor, color: 'white' }}
              >
                Suivre ma réclamation
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationStep;